const lang = {
  title_page: process.env.MIX_APP_NAME,
  form: {
    title: 'パスワード再設定 申込み',
    email: 'メールアドレス',
    email_label: 'メールアドレスを入力してください。',
    email_placeholder: 'メールアドレス',
    back_button: 'ログイン画面に戻る',
    submit_button: '送信する',
  },
}

export default lang
